$(document).ready(function() {
jQuery(document).on('click', '.remove-btn', function () {
  let variantId = $(this).parent(".cart__item").attr("data-key");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
     success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
                    var item_count = cart['item_count'];
                    var total_price = cart['total_price']/100;
                        $('.drawer-count .cart-count').text(item_count);
                        $('.cart__checkout div').text( total_price.toFixed(2)+ '€' );
                  if ( item_count == 0 ) {
                    $(".drawer.cart__drawer-custom").addClass("is-empty");
                  }
                  else if( item_count < 3 ){
                    removeFreeProduct()
                  }
                       }
            });
     }
  });
   $(this).parent(".cart__item").hide(); 
  });
   function removeFreeProduct() {
     let variantId = "40595956301875:20ceee47e721ed11f92becf5b08067a6";
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
     success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
                    var total_price = cart['total_price']/100;
                        $('.cart__checkout div').text( total_price.toFixed(2)+ '€' );
                  $(".cart-item-free").hide(); 
                   $(".drawer.cart__drawer-custom").addClass("is-empty");
                                       }
            });
     }
   });
   } 
  });
// ---------------------Remove link -------------
$(document).ready(function() {
jQuery(document).on('click', '.remove-link', function () {
  $(this).siblings(".js-qty__wrapper").find("input.js-qty__num").val(0)
  $(this).siblings(".js-qty__wrapper").find(".js-qty__adjust--minus").click(); 
    return false;
  });

  jQuery(document).on('click', '.remove-item', function () {
    
    $(this).parents(".cart__item--details").find("input.js-qty__num").val(0)
    $(this).parents(".cart__item--details").find(".js-qty__adjust--minus").click(); 
    return false;
  });

   jQuery(document).on('click', '.add-to-cart ', function () {
     // setInterval(function(){ 
     
     $(".drawer.cart__drawer-custom").removeClass("is-empty");
       $(this).siblings(".product-added").css("opacity", "1");


     setTimeout(function() {
       console.log("inside timeout");
       
        $(".product-added").css("opacity", "0");
      }, 5000);
   });
  });

 jQuery(document).on('click', '.jdgm-carousel-number-of-reviews ', function () {
    window.location.href = '/pages/avis-clients';
    return false;
});

$(document).mouseup(function(e) {
    var container = $(".megamenu");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.navigation__item').removeClass('is-open');
      }
   })

jQuery(document).on('touchend click', ".navigation__item", function (e) {
$(this).toggleClass("is-open");
  $(this).siblings().removeClass('is-open');
  });

// Scroll up 100px on anchor click
document.addEventListener('DOMContentLoaded', function() {
  // Method 1: Using data attribute
  const scrollUpAnchors = document.querySelectorAll('a[data-scroll-up="100"]');
  scrollUpAnchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: currentScroll - 100,
        behavior: 'smooth'
      });
    });
  });

  // Method 2: Using class
  const scrollUpClassAnchors = document.querySelectorAll('a.scroll-up-100');
  scrollUpClassAnchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: currentScroll - 100,
        behavior: 'smooth'
      });
    });
  });

  // Method 3: Flexible scroll amount
  const flexibleScrollAnchors = document.querySelectorAll('a[data-scroll-up]');
  flexibleScrollAnchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const scrollAmount = parseInt(this.getAttribute('data-scroll-up')) || 100;
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: currentScroll - scrollAmount,
        behavior: 'smooth'
      });
    });
  });
});

  
